import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {GroupUserDefine} from '../../../models/staff/groupuserdefine';
import {GroupUserDefineService} from '../../../service/staff/service-groupuserdefine';
import {GroupStaffsService} from '../../../service/staff/service-groupstaffs';
@Component({
  templateUrl: './userrole.component.html'

})export class UserRoleComponent implements OnInit {
  public language = language;
  public id: number = 0;
  public isEdit: boolean = false;
  public dataRoles: GroupUserDefine[] = [];
  public onClose: Subject<boolean>;
  public dataCheck: Object[]=[];


  constructor(

               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public groupUserDefineService: GroupUserDefineService,
               public groupStaffsService: GroupStaffsService
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();

  }
  public checkAll(event)
  {
    this.dataCheck = [];
      for ( let i = 0;i < this.dataRoles.length;i++) {
        if (event.target.checked === true) {
          this.dataCheck.push(this.dataRoles[i].id);
        }
        this.dataRoles[i].active = event.target.checked;
      }

  }
  public checkedItem(event)
  {
    if(event.target.checked === true && this.dataCheck.indexOf(Number(event.target.value)) === -1)
      this.dataCheck.push(event.target.value);
    else
      this.dataCheck.splice(this.dataCheck.indexOf(Number(event.target.value)), 1);
  }
  edit(id: number) {
    this.id = id;
        this.groupStaffsService.findByStaffId(id).subscribe(y => {
          for(let k = 0; k < y.length;k++)
            this.dataCheck.push(y[k].groupID);
          this.groupUserDefineService.getAll().subscribe(data => {
            this.dataRoles = data;
            for ( let i = 0; i < this.dataRoles.length; i++) {
              this.dataRoles[i].active= y.findIndex(x => x.groupID === this.dataRoles[i].id) !==-1 ? true: false;
            }

          });
        });
  }
  public loadChecked(id: number): boolean
  {
    return this.dataCheck.findIndex(x=>Number(x) == id)!=-1;
  }

  updateItem()
  {

    this.groupStaffsService.insertMultiGroup(this.id, this.dataCheck.join()).subscribe({
      next: (data) => {
        this.toastr.success(language.user_role_success, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
